// extracted by css-extract-rspack-plugin
export default {"tableControlsContainer":"tableControlsContainer-xvMbdB","tableControlsItemIcon":"tableControlsItemIcon-VQL21p","activeIcon":"activeIcon-n4yTXy"};